/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const loadScript = (src, async = true, type = "text/javascript") => {
  return new Promise((resolve, reject) => {
    try {
      const el = document.createElement("script");
      const container = document.head || document.body;

      el.type = type;
      el.async = async;
      el.src = src;

      el.addEventListener("load", () => {
        resolve({ status: true });
      });

      el.addEventListener("error", () => {
        reject({
          status: false,
          message: `Failed to load the script ${ src }`
        });
      });

      container.appendChild(el);
    } catch (err) {
      reject(err);
    }
  });
};


const initPlyrVideos = ({ videoElements }) => {
  videoElements.forEach(videoElement => {
    const controls = videoElement.hasAttribute('data-plyr-controls') ? ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'] : ['play-large'];
    const player = new Plyr(videoElement, {
      controls: controls,
      loop: {
        active: true
      },
      hideControlsOnPause: true,
      clickToPlay: true,
      iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
      tooltips: {
        controls: false,
        seek: true
      },
    });

    player.on('ready', () => {
      if (player.elements.original.classList.contains('embed-responsive')) {
        player.elements.wrapper.style.aspectRatio = 'unset';
      }

      if (videoElement.hasAttribute('muted')) {
        if (videoElement.getAttribute('muted') == 'true') {
          player.muted = true;
        }
        else {
          player.muted = false;
        }
      }
    });
  });
}

const whenReady = () => {

  const videoElements = document.querySelectorAll('[data-plyr-video]')

  if (videoElements.length > 0) {
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
    document.head.appendChild(stylesheet);

    loadScript("https://cdn.plyr.io/3.7.2/plyr.js")
      .then((data) => {
        //console.log("Plyr script loaded successfully", data);
        initPlyrVideos({ videoElements });
      })
      .catch((err) => {
        console.error(err);
      });


    // window.Shopify.loadFeatures([{
    //   name: 'video-ui',
    //   version: '1.0',
    //   onLoad: () => { initPlyrVideos({ videoElements }), initPlyrEmbeddedVideos({videoEmbeddedElements}) }
    // }]);
  }
}


if (document.readyState === 'complete' || document.readyState === 'interactive') {
  whenReady();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    whenReady();
  }, {
    once: true,
  });
}



// ================== SIZECHART OPEN/CLOSE

let sizeChartLinkFind = document.querySelectorAll(".Product__Tabs .Collapsible .Collapsible__Inner .Collapsible__Content p a");

sizeChartLinkFind.forEach(function(element) {
  if(element.getAttribute('href') === '#sizeguide') { 
    element.classList.add('sizeGuideLink')
  }
});

if(!!document.querySelector('.openSize'))
  document.querySelector('.openSize').addEventListener('click', openSizeGuideBtn);

if(!!document.querySelector('.closeSize'))
  document.querySelector('.closeSize').addEventListener('click', closeSizeGuide);


let createLink = document.createElement("div");
let createLinkInner = document.createElement('button');
createLinkInner.classList.add('Collapsible__Button', 'Heading', 'u-h6');

const getCurrentUrl = window.location.href;

let translateSizeChart = "Size chart";
if (currentUrl.indexOf('https://www.glerups.dk') !== -1){  
  translateSizeChart = "Størrelsesguide"
}
else if (currentUrl.indexOf('https://www.glerups.de') !== -1)
{
  translateSizeChart = "Größentabelle"
}
else if (currentUrl.indexOf('https://www.glerups.no') !== -1)
{
  translateSizeChart = "Størrelsesguide"
}




createLinkInner.textContent = translateSizeChart;
createLink.appendChild(createLinkInner);

createLink.classList.add('Collapsible');

if(!!document.querySelector('.Product__Tabs'))
  document.querySelector('.Product__Tabs').prepend(createLink);

createLink.addEventListener('click', function() {
  openSizeGuide()
});

function openSizeGuide (element) {
  let topSizeGuide = document.getElementById('sizeguide').offsetTop
  let heightOfHeader = document.querySelector('.Header__Wrapper').offsetHeight; 
  // element = document.getElementById("sizeguide");
  // element.scrollIntoView({ behavior: "smooth"}); 

  

  window.scrollTo({
    top: topSizeGuide - heightOfHeader,
    left: 100,
    behavior: 'smooth'
  });

  



  setTimeout(() => {
    if(!document.querySelector('.sizeguide').classList.contains('open')) { 
      document.querySelector('.sizeguide').classList.add('open');
    }
  }, "200");
}

function closeSizeGuide (element) {
  document.querySelector('.sizeguide').classList.remove('open');
}

function openSizeGuideBtn () {
  document.querySelector('.sizeguide').classList.add('open');
}

// Product details page - Fix no size selected initially
// window.addEventListener('DOMContentLoaded', (event) => {
//   if(window.location.pathname.indexOf('/products/') != -1 || window.location.pathname.indexOf('/collections/') != -1) {
//     var popoverForm = document.querySelector('.OptionSelector');

//     if(!!popoverForm) {
//       if(window.location.search.indexOf('variant=') == -1) {
//         var popoverValues = popoverForm.querySelectorAll('.Popover__Value');

//         if(!!popoverValues && popoverValues.length > 0) {
//           for (let i = 0; i < popoverValues.length; i++) {
//             var popoverValue = popoverValues[i];
            
//             if(!!popoverValue.dataset.variantId)
//             var variantId = popoverValue.dataset.variantId;
//             popoverValue.addEventListener('click', function (event) {  
//               event.stopPropagation();     
//               var searchParam = window.location.search == '' ? '?' : '&';
//               window.location = window.location.href + searchParam + 'variant=' + variantId;
//             });
//           }
//         }
//       }
//     }
//   }
// });

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details

  if(window.location.search.indexOf('variant=') == -1 && (window.location.pathname.indexOf('/products/') != -1 || window.location.pathname.indexOf('/collections/') != -1)) { 
    var searchParam = window.location.search == '' ? '?' : '&';
    window.location = window.location.href + searchParam + 'variant=' + variant.id;
  }
});




/*
document.addEventListener("DOMContentLoaded", () => {
  const bannerList = document.querySelector("#banner-list");
  const items = bannerList.querySelectorAll("li");
  let activeIndex = 0;

  function updateActiveItem() {
    // Remove active class from all items
    items.forEach((item) => item.classList.remove("active"));

    // Add active class to the current item
    items[activeIndex].classList.add("active");

    // Update active index
    activeIndex = (activeIndex + 1) % items.length; 
  }

  // Initialize active item for mobile view
  if (window.innerWidth <= 944) {
    items[0].classList.add("active");
    setInterval(updateActiveItem, 3000); 
  }
});
*/


document.addEventListener("DOMContentLoaded", () => {
  const bannerList = document.querySelector("#banner-list");
  if (!bannerList) {
    console.warn("Element with ID 'banner-list' not found.");
    return;
  }

  const items = bannerList.querySelectorAll("li");
  if (items.length === 0) {
    console.warn("No list items found inside 'banner-list'.");
    return;
  }

  let activeIndex = 0;
  let intervalId = null;

  function updateActiveItem() {
    // Remove active class from all items
    items.forEach((item) => item.classList.remove("active"));

    // Add active class to the current item
    items[activeIndex].classList.add("active");

    // Update active index
    activeIndex = (activeIndex + 1) % items.length;
  }

  function startAutoCycle() {
    // Initialize active item
    items[0].classList.add("active");
    intervalId = setInterval(updateActiveItem, 3000);
  }

  function stopAutoCycle() {
    clearInterval(intervalId);
    intervalId = null;
    // Remove active class from all items
    items.forEach((item) => item.classList.remove("active"));
  }

  function handleResize() {
    if (window.innerWidth <= 944 && !intervalId) {
      startAutoCycle();
    } else if (window.innerWidth > 944 && intervalId) {
      stopAutoCycle();
    }
  }

  // Check initial window size
  handleResize();

  // Make banner list visible after setup is complete
  bannerList.style.visibility = "visible";

  // Add resize event listener
  window.addEventListener("resize", handleResize);
});


// ============================= Header scripts - Makes the megamenu work ===============================



document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');

document.addEventListener("DOMContentLoaded", function () {
    const closeMenuButtons = document.querySelectorAll(".MegaMenu-close");
    closeMenuButtons.forEach((closeBtn) => {
        closeBtn.addEventListener("click", function () {
            const menuContainer = closeBtn.closest(".MegaMenu");
            if (menuContainer) {
                menuContainer.classList.remove("is-expanded");
                menuContainer.setAttribute("aria-hidden", "true");
            }
        });
    });

    /*
    document.querySelectorAll('.Linklist__Item a').forEach(link => {
        let regex = /New/gi;
        if (regex.test(link.textContent)) {
            link.innerHTML = link.innerHTML.replace(regex, '<span style="font-style: italic; font-weight: bold; font-size: 1.3rem; text-transform: uppercase;">$&</span>');
        }
    });
    */

  let beforeMenuWordTopNav = "New";
  
  var domain_top = window.location.hostname;
  if (domain_top.includes(".dk")) {
    beforeMenuWordTopNav = "Nyhed";
  }
  if (domain_top.includes(".de")) {
    beforeMenuWordTopNav = "Neue";
  }
  if (domain_top.includes(".no")) { 
    beforeMenuWordTopNav = "Nyhed";
  }

  document.querySelectorAll('.Linklist__Item a').forEach(link => {
    let regex = /New_/gi;
    if (regex.test(link.textContent)) {
      link.innerHTML = link.innerHTML.replace(
        regex,
        '<span style="font-style: italic; font-weight: bold; font-size: 1.3rem; text-transform: uppercase;">' + beforeMenuWordTopNav + '&nbsp;</span>'
      );
    }
  });










    const itemsA = document.querySelectorAll(".DropdownMenu");
    const overlay = document.querySelector(".overlay");
    function checkVisibility() {
        const anyVisible = Array.from(itemsA).some(item => item.getAttribute("aria-hidden") === "false");
        overlay.style.display = anyVisible ? "block" : "none";
    }
    checkVisibility();
    const observer = new MutationObserver(() => checkVisibility());
    itemsA.forEach(item => observer.observe(item, { attributes: true, attributeFilter: ["aria-hidden"] }));
    overlay.addEventListener("mouseenter", function () {
        itemsA.forEach(item => item.setAttribute("aria-hidden", "true"));
        checkVisibility();
    });

    const langSelector = document.querySelector('.lang-selector');
    const localizationForm = document.querySelector('#localization_form_header');
    if (langSelector && localizationForm) {
        langSelector.appendChild(localizationForm);
    }

    const dropdownObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'aria-hidden') {
                const dropdown = mutation.target;
                const sibling = dropdown.parentElement.querySelector('.sibling');
                if (dropdown.getAttribute('aria-hidden') === 'false') {
                    sibling?.classList.add('active');
                } else {
                    sibling?.classList.remove('active');
                }
            }
        });
    });
    document.querySelectorAll('.DropdownMenu').forEach((menu) => {
        dropdownObserver.observe(menu, { attributes: true });
    });

    /*
    ===================================== NAVIGATION ADD SPECIAL STYLING ON _ ==============
    */

    const hasHeader = document.querySelector('.Header__Wrapper');
    const hasSubmenu = document.querySelector('#sidebar-menu');

    if (hasHeader) {
      document.querySelectorAll('.HorizontalList__Item.first-menu a').forEach(link => {
        let regex = /_/gi;
    
        // Loop through child nodes to find the text node
        link.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && regex.test(node.textContent)) {
            const cleanedText = node.textContent.replace(regex, ' ').trim();
    
            // Replace the original text node with a span
            const span = document.createElement('span');
            span.className = 'langdal-menuitem';
            span.textContent = cleanedText;
    
            link.replaceChild(span, node);
          }
        });
      });
    }

    if (hasSubmenu) {
      //console.log('is in mobile loop')
      document.querySelectorAll('.Collapsible__Button').forEach(mobilemenuLink => {
        let regex = /_/gi;
    
        // Loop through child nodes to find the text node
        mobilemenuLink.childNodes.forEach(mobilenode => {
          if (mobilenode.nodeType === Node.TEXT_NODE && regex.test(mobilenode.textContent)) {
            const cleanedText = mobilenode.textContent.replace(regex, ' ').trim();
    
            // Replace the original text node with a span
            const span = document.createElement('span');
            span.className = 'langdal-menuitem';
            span.textContent = cleanedText;
    
            mobilemenuLink.replaceChild(span, mobilenode); 
          }
        });
      });

    }





    
  // Insert .boost-pfs-filter-option-model before .boost-pfs-filter-option-sal
  var modelOption = document.querySelector('.boost-pfs-filter-option-model');
  var salOption = document.querySelector('.boost-pfs-filter-option-sal');
  if (modelOption && salOption && salOption.parentNode) {
    salOption.parentNode.insertBefore(modelOption, salOption);
  }



    


    
});







// ============================= End Header scripts - Makes the megamenu work ===============================


// ============================= Shopping Cart showing amount in basket 19-02-2026 ===============================


(() => {
  const getBadges = () => document.querySelectorAll('[data-cart-count], .Header__CartDot');

  const renderCount = (count) => {
    getBadges().forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  };

  const refreshCount = async () => {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      renderCount(cart.item_count);
    } catch (e) {}
  };

  // Initial load
  document.addEventListener('DOMContentLoaded', refreshCount);

  // 1) Hook into common cart endpoints (works with cart drawer + AJAX add)
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const p = originalFetch(input, init);

    try {
      const url = typeof input === 'string' ? input : input.url;
      if (/\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
        return p.then((r) => {
          if (r.ok) queueMicrotask(refreshCount);
          return r;
        });
      }
    } catch (e) {}

    return p;
  };

  // 2) Also listen for theme/app custom events (safe no-ops if not used)
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach((evt) => {
    document.addEventListener(evt, refreshCount);
  });
})();

